'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.warnDeprecated = exports.clauseReducesResultSetSize = exports.clauseFiltersByAttribute = exports.getBatchToken = exports.arrayDiffActions = exports.includes = exports.ops = exports.objectShallowEquals = exports.reverseFieldErrorMessage = exports.normalizeEntity = exports.reverseFieldName = exports.m2mToFieldName = exports.m2mFromFieldName = exports.m2mName = exports.attachQuerySetMethods = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _forOwn = require('lodash/forOwn');

var _forOwn2 = _interopRequireDefault(_forOwn);

var _includes = require('lodash/includes');

var _includes2 = _interopRequireDefault(_includes);

var _immutableOps = require('immutable-ops');

var _immutableOps2 = _interopRequireDefault(_immutableOps);

var _intersection = require('lodash/intersection');

var _intersection2 = _interopRequireDefault(_intersection);

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function warnDeprecated(msg) {
    var logger = typeof console.warn === 'function' ? console.warn.bind(console) : console.log.bind(console);
    return logger(msg);
}

function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function m2mName(declarationModelName, fieldName) {
    return declarationModelName + capitalize(fieldName);
}

function m2mFromFieldName(declarationModelName) {
    return 'from' + declarationModelName + 'Id';
}

function m2mToFieldName(otherModelName) {
    return 'to' + otherModelName + 'Id';
}

function reverseFieldName(modelName) {
    return modelName.toLowerCase() + 'Set';
}

function querySetDelegatorFactory(methodName) {
    return function querySetDelegator() {
        var _getQuerySet;

        return (_getQuerySet = this.getQuerySet())[methodName].apply(_getQuerySet, arguments);
    };
}

function querySetGetterDelegatorFactory(getterName) {
    return function querySetGetterDelegator() {
        var qs = this.getQuerySet();
        return qs[getterName];
    };
}

function forEachSuperClass(subClass, func) {
    var currClass = subClass;
    while (currClass !== Function.prototype) {
        func(currClass);
        currClass = (0, _getPrototypeOf2.default)(currClass);
    }
}

function attachQuerySetMethods(modelClass, querySetClass) {
    var leftToDefine = querySetClass.sharedMethods.slice();

    forEachSuperClass(querySetClass, function (cls) {
        for (var i = 0; i < leftToDefine.length; i++) {
            var defined = false;
            var methodName = leftToDefine[i];
            var descriptor = (0, _getOwnPropertyDescriptor2.default)(cls.prototype, methodName);
            if (typeof descriptor !== 'undefined') {
                if (typeof descriptor.get !== 'undefined') {
                    descriptor.get = querySetGetterDelegatorFactory(methodName);
                    (0, _defineProperty2.default)(modelClass, methodName, descriptor);
                    defined = true;
                } else if (typeof descriptor.value === 'function') {
                    modelClass[methodName] = querySetDelegatorFactory(methodName);
                    defined = true;
                }
            }
            if (defined) {
                leftToDefine.splice(i--, 1);
            }
        }
    });
}

function normalizeEntity(entity) {
    if (entity !== null && typeof entity !== 'undefined' && typeof entity.getId === 'function') {
        return entity.getId();
    }
    return entity;
}

function reverseFieldErrorMessage(modelName, fieldName, toModelName, backwardsFieldName) {
    return ['Reverse field ' + backwardsFieldName + ' already defined', ' on model ' + toModelName + '. To fix, set a custom related', ' name on ' + modelName + '.' + fieldName + '.'].join('');
}

function objectShallowEquals(a, b) {
    var keysInA = 0;

    (0, _forOwn2.default)(a, function (value, key) {
        if (!b.hasOwnProperty(key) || b[key] !== value) {
            return false;
        }
        keysInA++;
    });

    return keysInA === (0, _keys2.default)(b).length;
}

function arrayDiffActions(sourceArr, targetArr) {
    var itemsInBoth = (0, _intersection2.default)(sourceArr, targetArr);
    var deleteItems = (0, _difference2.default)(sourceArr, itemsInBoth);
    var addItems = (0, _difference2.default)(targetArr, itemsInBoth);

    if (deleteItems.length || addItems.length) {
        return {
            delete: deleteItems,
            add: addItems
        };
    }
    return null;
}

var getBatchToken = _immutableOps2.default.getBatchToken;


function clauseFiltersByAttribute(_ref, attribute) {
    var type = _ref.type,
        payload = _ref.payload;

    if (type !== _constants.FILTER) return false;

    if ((typeof payload === 'undefined' ? 'undefined' : (0, _typeof3.default)(payload)) !== 'object') {
        return false;
    }

    if (!payload.hasOwnProperty(attribute)) return false;
    var attributeValue = payload[attribute];
    if (attributeValue === null) return false;
    if (attributeValue === undefined) return false;

    return true;
}

function clauseReducesResultSetSize(_ref2) {
    var type = _ref2.type;

    return [_constants.FILTER, _constants.EXCLUDE].includes(type);
}

exports.attachQuerySetMethods = attachQuerySetMethods;
exports.m2mName = m2mName;
exports.m2mFromFieldName = m2mFromFieldName;
exports.m2mToFieldName = m2mToFieldName;
exports.reverseFieldName = reverseFieldName;
exports.normalizeEntity = normalizeEntity;
exports.reverseFieldErrorMessage = reverseFieldErrorMessage;
exports.objectShallowEquals = objectShallowEquals;
exports.ops = _immutableOps2.default;
exports.includes = _includes2.default;
exports.arrayDiffActions = arrayDiffActions;
exports.getBatchToken = getBatchToken;
exports.clauseFiltersByAttribute = clauseFiltersByAttribute;
exports.clauseReducesResultSetSize = clauseReducesResultSetSize;
exports.warnDeprecated = warnDeprecated;